import React from 'react';
import Reflux from 'reflux';
import './Comment.css';
import TopItem from './TopItem';

const optionsStructure = [
    {
        position: 1,
        sentence: ''
    }, {
        position: 2,
        sentence: ''
    }, {
        position: 3,
        sentence: ''
    }, {
        position: 4,
        sentence: ''
    }, {
        position: 5,
        sentence: ''
    }
];

class TopList extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            tops: this.props.tops || []
        };
    }
    searchPosition (position, options) {
        let option = options.find((newOption) => {
            return parseInt(newOption.position) === parseInt(position);
        });
        return option;
    }
    orderOptions (optionsTopic) {
        let options = optionsStructure;
        options = options.map((option) => {
            const newOption = this.searchPosition(option.position, optionsTopic);
            if (newOption) {
                option = newOption;
            }
            return option;
        });
        return options;
    }
    componentWillReceiveProps (newProps) {
        if (newProps.tops) {
            this.setState({
                tops: newProps.tops
            });
        }
    }
    render () {
        let listTops = this.state.tops.map((topic) => {
            topic.options = this.orderOptions(topic.options);
            return <TopItem key={topic._id} topic={topic} prefix={this.state.prefix} />;
        });
        return <ul className='boxListGrid'>{listTops}</ul>;
    }
}

export default TopList;



// WEBPACK FOOTER //
// ./src/sections/TopList.js